import { getGtmData } from '..';

const portfolio = () => ({
  onPortfolioPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/home',
    //   title: 'PFM - Online Investments - Portfolio - Home',
    //   cd24: getGtmData('cd24'),
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen',
    // });
  },
  onClickOfNotification: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/home/notifications',
    //   title: 'PFM - Online Investments - Portfolio - Home - Notifications',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Notifications',
    // });
  },
  onClickOfCurrentValueCard: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Investment Details',
    // });
  },
  onClickOfSIPDueCard: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - SIP Due On',
    // });
  },
  onClickHoldings: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Holdings',
    // });
  },
  onClickStatements: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Statements',
    // });
  },
  onClickTransactions: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Transactions',
    // });
  },
  onClickInsights: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - Insights',
    // });
  },
  onClickProfile: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - Landing Screen - My Profile',
    // });
  },
  onHoldingPageLoad: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_vpv',
    //   page: 'vpv/pfm/online-investments/portfolio/my-holdings',
    //   title: 'PFM - Online Investments - Portfolio - My Holdings',
    // });
    // recordEventWrapper({
    //   event: 'event_PFM_on_page_load_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings',
    // });
  },
  onClickHoldingPageBackButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Back',
    // });
  },
  onClickHoldingsPageTransactionButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Transactions',
    // });
  },
  onClickHoldingsPageStatementsButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Statements',
    // });
  },
  onClickHoldingPageExploreFundsButton: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Explore Funds',
    // })
  },
  onClickInvestMore: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - ' + schemeName + ' - Invest More',
    // });
  },
  onClickSwitchOrSTP: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - ' + schemeName + ' - Switch / STP',
    // });
  },
  onClickRedeemOrSWP: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - ' + schemeName + ' - Redeem / SWP',
    // });
  },
  onSelectAnnualizedReturnToggle: () => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - Show Annualized Return',
    // });
  },
  onClickSchemeNameINHoldingsPage: (schemeName: string) => {
    // recordEventWrapper({
    //   event: 'event_PFM_on_click_event',
    //   category: 'PFM',
    //   action: 'Online Investments',
    //   label: 'Portfolio - My Holdings - ' + schemeName,
    // });
  },
});
export default portfolio;
